<div class="navbar-header" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">
  <button mat-icon-button (click)="toggleSidebarFolded()" class="toggle-sidebar-folded fx-hide-lt-lg">
    <mat-icon>menu</mat-icon>
  </button>

  <div class="logo"><img src="assets/images/logos/tangerine_logo_white.svg" /></div>

  <button mat-icon-button (click)="toggleSidebarOpened()" class="toggle-sidebar-opened fx-hide-gt-md">
    <mat-icon>arrow_back</mat-icon>
  </button>
</div>

@if (domainLogoId) {
  <div class="logo-mobile fuse-navy-900 fx-column">
    <img class="logo-icon" [src]='_appService.getBaseServerAddressRoot() + "/document_files/download/" + domainLogoId' alt="Logo Img" />
  </div>
}

<div class="navbar-content" fusePerfectScrollbar
  [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
  [ngClass]="fuseConfig.layout.navbar.primaryBackground">
  <fuse-navigation layout="vertical"></fuse-navigation>
</div>
